import {Action, Catalog} from '../../../../../common/types/common';
import {CommissionBankAccountSummaryDTO} from '../../types/mx/epics';
import {
    CommissionBankAccountFile,
    CommissionBankAccountFileType,
    CommissionBankAccountState
} from '../../../../group/types/mx/types';
import {BankAccountFormType} from '../../../../group/types/mx/containers';
import {CommissionBankAccountDTO} from '../../../../group/types/mx/epics';

export const CHANGE_COMMISSION_BANK_ACCOUNT_NUMBER_ACTION: Action = {
    name: 'CHANGE_COMMISSION_BANK_ACCOUNT_NUMBER_ACTION',
    action: (accountNumber: string, error: string = null) => ({
        accountNumber, error,
        type: CHANGE_COMMISSION_BANK_ACCOUNT_NUMBER_ACTION.name
    })
};

export const CHANGE_COMMISSION_BANK_ACTION: Action = {
    name: 'CHANGE_COMMISSION_BANK_ACTION',
    action: (bank: Catalog, error: string = null) => ({
        bank, error,
        type: CHANGE_COMMISSION_BANK_ACTION.name
    })
};

export const CHANGE_COMMISSION_BENEFICIARY_ACTION: Action = {
    name: 'CHANGE_COMMISSION_BENEFICIARY_ACTION',
    action: (beneficiary: string, error: string = null) => ({
        beneficiary, error,
        type: CHANGE_COMMISSION_BENEFICIARY_ACTION.name
    })
};

export const CHANGE_COMMISSION_CLABE_ACTION: Action = {
    name: 'CHANGE_COMMISSION_CLABE_ACTION',
    action: (clabe: string, error: string = null) => ({
        clabe, error,
        type: CHANGE_COMMISSION_CLABE_ACTION.name
    })
};

export const DROP_COMMISSION_FILE_ACCOUNT_ACTION: Action = {
    name: 'DROP_COMMISSION_FILE_ACCOUNT_ACTION',
    action: (file: CommissionBankAccountFile, error: string = null) => ({
        file, error,
        type: DROP_COMMISSION_FILE_ACCOUNT_ACTION.name
    })
};

export const DROP_COMMISSION_FILE_IDENTIFICATION_ACTION: Action = {
    name: 'DROP_COMMISSION_FILE_IDENTIFICATION_ACTION',
    action: (file: CommissionBankAccountFile, error: string = null) => ({
        file, error,
        type: DROP_COMMISSION_FILE_IDENTIFICATION_ACTION.name
    })
};

export const DELETE_COMMISSION_FILE_SUCCESS_ACTION: Action = {
    name: 'DELETE_COMMISSION_FILE_SUCCESS_ACTION',
    action: (fileId: string, fileType: CommissionBankAccountFileType, error: string = null) => ({
        fileId, fileType, error,
        type: DELETE_COMMISSION_FILE_SUCCESS_ACTION.name
    })
};

export const COMMISSION_BANK_ACCOUNT_SAVE_ACTION: Action = {
    name: 'COMMISSION_BANK_ACCOUNT_SAVE_ACTION',
    action: (fromForm: boolean = true, formType: BankAccountFormType = BankAccountFormType.CREATE_FORM_FROM_LOAN) => ({
        fromForm, formType,
        type: COMMISSION_BANK_ACCOUNT_SAVE_ACTION.name
    })
};

export const GOT_COMMISSION_BANK_ACCOUNT: Action = {
    name: 'GOT_COMMISSION_BANK_ACCOUNT',
    action: (commissionBankAccount: CommissionBankAccountSummaryDTO) => ({
        commissionBankAccount,
        type: GOT_COMMISSION_BANK_ACCOUNT.name
    })
};

export const GET_COMMISSION_BANK_ACCOUNT_LIST_ACTION: Action = {
    name: 'GET_COMMISSION_BANK_ACCOUNT_LIST_ACTION',
    action: (groupId: string) => ({
        groupId,
        type: GET_COMMISSION_BANK_ACCOUNT_LIST_ACTION.name
    })
};

export const GOT_COMMISSION_BANK_ACCOUNT_LIST_ACTION: Action = {
    name: 'GOT_COMMISSION_BANK_ACCOUNT_LIST_ACTION',
    action: (commissionBankAccountsList: CommissionBankAccountDTO[]) => ({
        commissionBankAccountsList,
        type: GOT_COMMISSION_BANK_ACCOUNT_LIST_ACTION.name
    })
};

export const ADD_ITEM_COMMISSION_BANK_ACCOUNT_LIST_ACTION: Action = {
    name: 'ADD_ITEM_COMMISSION_BANK_ACCOUNT_LIST_ACTION',
    action: (commissionBankAccount: CommissionBankAccountState) => ({
        commissionBankAccount,
        type: ADD_ITEM_COMMISSION_BANK_ACCOUNT_LIST_ACTION.name
    })
};

export const CHANGE_COMMISSION_BANK_ACCOUNT_REGISTER_DATE_ACTION: Action = {
    name: 'CHANGE_COMMISSION_BANK_ACCOUNT_REGISTER_DATE_ACTION',
    action: (date: string, fromForm: boolean = true, error: string = null) => ({
        date, fromForm, error,
        type: CHANGE_COMMISSION_BANK_ACCOUNT_REGISTER_DATE_ACTION.name
    })
};

export const CHANGE_COMMISSION_BANK_ACCOUNT_ACTION: Action = {
    name: 'CHANGE_COMMISSION_BANK_ACCOUNT_ACTION',
    action: (data: CommissionBankAccountDTO, fromForm: boolean = true, error: string = null) => ({
        data, fromForm, error,
        type: CHANGE_COMMISSION_BANK_ACCOUNT_ACTION.name
    })
};